export default {
    title_list: 'Партнерские промо коды',
    title_page: 'Партнерский промо код',
    title_create_page: 'Создать партнерский промо код',
    title_edit_page: 'Изменить партнерский промо код',

    filter: {
        labels: {
            code: 'Промо код',
            partner: 'Партнер',
        }
    },

    table: {
        labels: {
            id: 'ID',
            code: 'Промо код',
            partner: 'Партнер',
            plan: 'Тарифный план',
            user: 'Пользователь',
            activated: 'Активирован',
            created_at: 'Создан'
        }
    },

    buttons: {
        generate: 'Сгенерировать код',
    },

    form: {
        code: 'Промо код',
        partner: 'Партнер',
        plan_id: 'Тариф',
        user_id: 'Пользователь',
        activated: 'Использован',
        activated_at: 'Дата использования'
    },
}
